import { GET_MISSIONS, SINGLE_MISSION, MISSION_FEEDBACK, CREATE_RIDE, SCAVENGER_DROPS, REACHED_SCAVENGER_DROPS_CHECKPOINT, REACHED_SCAVENGER_DROPS_CHECKPOINT_DATA, REACHED_SCAVENGER_DROPS_FLAG, REACHED_LATEST_NFT_DROPS_CHECKPOINT, REACHED_NFT_DROPS, CLEAR_REDUX, REACHED_NFT_DROPS_LIST, FAILED_MINTED_NFT_DROP, FAILED_MINTED_NFT_DROPS_LIST } from '../actionTypes';

const initialState = {
    missionDetails: "",
    singleMissionData: "",
    missionFeedback: '',
    createRide: '',
    scavengerDrops: [],
    reachedScavengerDropsCheckpoint: false,
    reachedScavengerDropsCheckpointData: [],
    reachedScavengerDropsFlag: true,
    reachedLatestNftDropsCheckPoint: '',
    reachedNftDrops: false,
    reachedNftDropsList: [],
    failedMintedDrop: null,
    failedMintedDropsList: []
}

export const missionReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MISSIONS:
            return {
                ...state,
                missionDetails: action.payload
            }
        case SINGLE_MISSION:
            return {
                ...state,
                singleMissionData: action.payload
            }
        case MISSION_FEEDBACK:
            return {
                ...state,
                missionFeedback: action.payload
            }
        case CREATE_RIDE:
            return {
                ...state,
                createRide: action.payload
            }
        case SCAVENGER_DROPS:
            return {
                ...state,
                scavengerDrops: action.payload
            }
        case REACHED_SCAVENGER_DROPS_CHECKPOINT:
            return {
                ...state,
                reachedScavengerDropsCheckpoint: action.payload
            }
        case REACHED_SCAVENGER_DROPS_CHECKPOINT_DATA:
            return {
                ...state,
                reachedScavengerDropsCheckpointData: action.payload
            }
        case REACHED_SCAVENGER_DROPS_FLAG:
            return {
                ...state,
                reachedScavengerDropsFlag: action.payload
            }
        case REACHED_LATEST_NFT_DROPS_CHECKPOINT:
            return {
                ...state,
                reachedLatestNftDropsCheckPoint: action.payload
            }
        case REACHED_NFT_DROPS:
            return {
                ...state,
                reachedNftDrops: action.payload
            }
        case REACHED_NFT_DROPS_LIST:
            return {
                ...state,
                reachedNftDropsList: [...state.reachedNftDropsList, action.payload]
            }

        case FAILED_MINTED_NFT_DROP:
            return {
                ...state,
                failedMintedDrop: action.payload
            }
        case FAILED_MINTED_NFT_DROPS_LIST:
            return {
                ...state,
                failedMintedDropsList: [...state.failedMintedDropsList, action.payload]
            }
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}
